import { SvgIconProps } from './icon-props';

export default function Beach({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			version="1.2"
			baseProfile="tiny-ps"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
		>
			<path
				fillRule="evenodd"
				d="m7.86 24.17-1.42 4.14c-.05.14-.15.26-.29.32-.14.07-.29.07-.43.03a.587.587 0 0 1-.33-.29.537.537 0 0 1-.03-.43l1.3-3.77H3.57a.62.62 0 0 1-.23-.04.615.615 0 0 1-.19-.12.497.497 0 0 1-.13-.19.585.585 0 0 1-.05-.22c0-.08.02-.15.05-.22.03-.07.07-.13.13-.19a.587.587 0 0 1 .42-.16h12.4l-3.12-10.87-8.4 2.41a.582.582 0 0 1-.53-.11.533.533 0 0 1-.16-.23.635.635 0 0 1-.04-.27c.2-2 .96-3.89 2.19-5.48a10.73 10.73 0 0 1 4.77-3.47l-.28-.99c-.04-.15-.02-.3.05-.44a.572.572 0 0 1 .56-.29.572.572 0 0 1 .48.41l.28.99c1.96-.42 4-.28 5.88.41s3.53 1.9 4.76 3.48c.06.07.1.16.11.25.02.09.01.19-.02.28-.03.09-.08.17-.15.23-.07.07-.15.11-.24.14l-8.19 2.35 3.04 10.62 1.92-2.25c.05-.06.12-.11.2-.15.08-.03.16-.05.24-.05h6.03l2.63-2.84a.553.553 0 0 1 .62-.14c.07.03.13.07.19.12.05.05.1.11.13.18a.57.57 0 0 1 .01.44.76.76 0 0 1-.12.19l-5.61 6.04c-.05.06-.12.1-.19.13s-.15.05-.23.05h-1.32l1.64 3.73c.06.14.05.29 0 .43a.57.57 0 0 1-.73.32.568.568 0 0 1-.32-.29l-1.84-4.19H7.82zm16.46-3.02h-4.71l-1.6 1.88h4.56l1.74-1.88zM7.25 8.66A9.396 9.396 0 0 0 5 13.22l15.97-4.58a9.472 9.472 0 0 0-4.33-2.68 9.363 9.363 0 0 0-5.09-.03c-1.66.5-3.14 1.44-4.3 2.72z"
			/>
		</svg>
	);
}
